import React from "react";
import { TableRow, TableCell } from "@material-ui/core";
import { DPTable, DPErrorMessage, DPComponentLoader } from "Components/DP";
import pretty from "Shared/pretty";
import useStyles from "./styles";
import { ROWS_PER_COMPLIANCE_REPORT_PAGE } from "../../ComplianceReports";
import { useReportHeaderOptions } from "Components/Shared/Reports/useReportHeaderOpions";
import { useCashBalanceReportHook } from "../useCashBalanceReportHook";

const CashBalaneTableHeaders = [
  "User ID",
  "Pay Group",
  "Pay Period End Date",
  "Funds Remitted to DPA",
  "Transferred to User (with fees)",
  "Negative Balance",
];

export const CashBalanceTable = () => {
  const classes = useStyles();
  const { data, onChangePage, loading, error, page } = useCashBalanceReportHook();
  const { visibleHeaders, showPayGroupColumn } = useReportHeaderOptions(
    CashBalaneTableHeaders
  );

  if (error) return <DPErrorMessage />;

  return (
    <DPTable
      className={classes.table}
      headers={visibleHeaders}
      rowsPerPage={ROWS_PER_COMPLIANCE_REPORT_PAGE}
      count={data?.totalCount}
      onChangePage={onChangePage}
      loading={loading}
      page={page}
    >
      <DPComponentLoader
        isLoading={loading}
        kind="table"
        awaitComponent={(
          <>
            {data?.items?.map(cashBalance => (
              <TableRow hover key={cashBalance.id}>
                <TableCell>
                  {cashBalance.providerAccountExternalId}
                </TableCell>
                {
                  showPayGroupColumn && (
                    <TableCell>
                      {cashBalance.company.payGroup}
                    </TableCell>
                  )
                }
                <TableCell>
                  {pretty.date(cashBalance.endsAtDate)}
                </TableCell>
                <TableCell>
                  {
                    typeof cashBalance.summary.netEarningsAmountCents === "number"
                      && pretty.dollar(cashBalance.summary.netEarningsAmountCents)
                  }
                </TableCell>
                <TableCell>
                  {
                    pretty.dollar(
                      cashBalance.summary.totalTransferredEarlyAmountCents +
                        (cashBalance.summary.remainderAmountCents || 0)
                    )
                  }
                </TableCell>
                <TableCell>
                  {
                    typeof cashBalance.summary.negativeBalancePaidSettlementAmountCents === "number"
                      && pretty.dollar(cashBalance.summary.negativeBalancePaidSettlementAmountCents)
                  }
                </TableCell>
              </TableRow>
            ))}
          </>
        )}
      />
    </DPTable>
  );
};
